import themeGet from '@styled-system/theme-get';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { Flex } from '../Flex/Flex';
import { Grid } from '../Grid/Grid';
const GappedFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ChatActionContainer__GappedFlex",
  componentId: "sc-fac0gy-0"
})(["gap:", ";"], themeGet('space.2'));
/**
 * @public
 */
export function ChatActionContainer({
  chatActions
}) {
  const actions = useMemo(() => {
    return chatActions.map(chatAction => React.createElement(Button, {
      key: chatAction.label,
      boxShadowSize: 'sm',
      variation: 'white',
      onClick: chatAction.onClick
    }, chatAction.label));
  }, [chatActions]);
  if (chatActions?.length === 2) {
    return React.createElement(Grid, {
      templateColumns: '1fr 1fr',
      gap: 2
    }, actions);
  } else {
    return React.createElement(GappedFlex, {
      flexDirection: ['column', null, 'row'],
      flexWrap: ['none', null, 'wrap']
    }, actions);
  }
}